import { ReactElement, RefObject } from 'react';
import { useSelector } from 'react-redux';
import { getDealFormReadOnly } from 'store/dealManagement/selectors/getDealFormReadOnly';
import DealActions from 'components/pages/DealWithLines/common/Main/ControllerBar/DealActions';
import LineActions from 'components/pages/DealWithLines/common/Main/ControllerBar/LineActions';
import { DealType } from 'components/common/types/Deal.types';
import { getDealType } from 'store/dealManagement/selectors/getDealType';
import { useDealAndLineActions } from '../../hooks/useDealAndLineActions';

interface ControllerBarProps {
  dealRef?: RefObject<HTMLElement | null> | null;
}

const ControllerBar = ({ dealRef = null }: ControllerBarProps): ReactElement | null => {
  const dealType = useSelector(getDealType);
  const readOnly = useSelector(getDealFormReadOnly);

  const { createLineHandler, deleteLineHandler, stopLineHandler, updateLineHandler, checkAllocateHandler, saveDeal } =
    useDealAndLineActions();

  if (readOnly && dealType === DealType.GUARANTEED) return null;

  return (
    <div
      className="flex bg-neutral-50 py-2.5 rounded-t-xl border border-neutral-950-opacity-10 divide-x divide-neutral-950-opacity-10 sticky bottom-0 w-max m-auto shadow-lg"
      data-test-id="controller-bar"
    >
      <LineActions
        createLine={createLineHandler}
        updateLine={updateLineHandler}
        deleteLine={deleteLineHandler}
        terminateLine={stopLineHandler}
      />
      <DealActions saveDeal={saveDeal} checkAllocate={checkAllocateHandler} dealRef={dealRef} />
    </div>
  );
};

export default ControllerBar;
